import { Dispatch } from "redux";
import { AlertModalModel } from "../../../models/AlertModal.model";

import { AlertDispatchType, SET_ALERT } from "./AlertActionType";

export const SetAlert = (alert: AlertModalModel) => (dispatch: Dispatch<AlertDispatchType>) => {
    try {
        dispatch({
            type: SET_ALERT,
            payload: {
                alert: alert,
            },
        });
    } catch (e) {
        dispatch({
            type: SET_ALERT,
            payload: {
                alert: alert
            }
        });
    }
};
